module.exports = __webpack_public_path__ + "img/zhaopin.b5bdeea8.png";